import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to manage page transition states
 * Adds a brief loading state when navigating between pages
 */
export const usePageTransition = () => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsTransitioning(true);
    
    // Reset scroll position to top
    window.scrollTo(0, 0);
    
    // Brief delay to show transition
    const timer = setTimeout(() => {
      setIsTransitioning(false);
    }, 300);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return isTransitioning;
};
